import http from "../utility/http";

/**
 * Pharmacy software integrations. The connection endpoints are platform-admin only; the two
 * request-scoped calls are what the Software tab in the transfer request modal uses.
 *
 * Credentials are write-only by design: the list endpoint returns short previews, never the
 * stored key or secret, so there is nothing to read back into the edit form.
 */

const ListConnections = async () => {
  return await http.get("/v1/pharmacy-software/connections");
};

const CreateConnection = async (payload) => {
  return await http.post("/v1/pharmacy-software/connections", payload);
};

const UpdateConnection = async (id, payload) => {
  return await http.put(`/v1/pharmacy-software/connections/${id}`, payload);
};

const DeleteConnection = async (id) => {
  return await http.delete(`/v1/pharmacy-software/connections/${id}`, {});
};

const TestConnection = async (id) => {
  return await http.post(`/v1/pharmacy-software/connections/${id}/test`, {});
};

/** Connected software, readiness checklist, request summary and send history in one call. */
const GetForRequest = async (requestId) => {
  return await http.get(`/v1/transfer/transfer-request/${requestId}/software`);
};

/**
 * Pushes the prescription to the pharmacy software. A rejection by the vendor still resolves
 * successfully with `status: "failed"` plus the step trail, so callers must check `status` rather
 * than assume success.
 */
const Send = async (requestId, sendMode) => {
  return await http.post(`/v1/transfer/transfer-request/${requestId}/software/send`, {
    sendMode,
  });
};

/** Prescription sheet Pioneer stores as scriptImage, as `{ mimeType, base64 }`. */
const GetScriptImage = async (requestId) => {
  return await http.get(`/v1/transfer/transfer-request/${requestId}/software/script-image`);
};

const api = {
  ListConnections,
  CreateConnection,
  UpdateConnection,
  DeleteConnection,
  TestConnection,
  GetForRequest,
  Send,
  GetScriptImage,
};

export default api;
